
import get from 'lodash/get';

import getStylesFromCssString from './getStylesFromCssString';

const getStylesFromDefinition = (definition, stylePath) => {
    const cssString = get(definition, stylePath, '');
    return getStylesFromCssString(cssString);
}

export default getStylesFromDefinition;
